import { render, staticRenderFns } from "./KindaiView.vue?vue&type=template&id=763d4a5a&scoped=true&"
import script from "./KindaiView.vue?vue&type=script&lang=js&"
export * from "./KindaiView.vue?vue&type=script&lang=js&"
import style0 from "./KindaiView.vue?vue&type=style&index=0&id=763d4a5a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "763d4a5a",
  null
  
)

export default component.exports